module.exports = __webpack_public_path__ + "static/media/197.3b799618.jpg";